
import { mapState } from "vuex"
import { judgeDeviceType } from "@/utils/device"
import $ from "jquery";
const keyboardHeightCache = {}; // 键盘高度缓存

const winHeight = window.innerHeight
/**
 * inputModalRef 输入框节点
 */
export default {
  mounted() {
    if (judgeDeviceType.isAndroid && this.onAndroidKeyboardDownEvent) {
      $(window).on('resize', this.onAndroidKeyboardDown)
    }
  },
  beforeDestroy() {
    $(window).off('resize', this.onAndroidKeyboardDown)
  },
  data() {
    this.windowHeight = winHeight; // 窗口高度
    this.inputModalHeight = 0; // 输入框高度
  },
  computed: {
    ...mapState(["cachedKeyboardHeight"]),
  },
  methods: {
    // 调用此函数前要保证inputModalRef节点已经存在于dom上面
    // 聚焦输入框，显示键盘
    showKeyboard() {
      this.$nextTick(() => {
        const $modal = this.$refs.inputModalRef
        if(!$modal){
          return
        }
        // 键盘没有高度前，隐藏输入框在页面顶部
        $modal.style.top = '0px'
        $modal.style.opacity = 0
        // 保存输入框高度
        this.inputModalHeight = this.$refs.inputModalRef.offsetHeight;
        // 设置键盘触发源，从而不触发editor页面的键盘响应
        this.$store.state.keyboardTrigger = 'input-modal-mixin';
        // 显示键盘
        $modal.querySelector('input').focus()
      })
    },

    /**
     * 聚焦时显示输入框
     * @param {*} keyboardType 键盘类型
     * @param {*} [minTopOffset=0] 输入框距离顶部的最小距离
     * @param {*} [adjustInputModalHeight=false] 是否自动调整输入框高度
     */
    showInputModal({
      keyboardType = 'text',
      minTopOffset = 0,
      adjustInputModalHeight = false
    }) {
      // 获得键盘高度时，显示输入框到正确的位置
      setTimeout(
        () => {
          if (
            this.cachedKeyboardHeight > 0 &&
            this.cachedKeyboardHeight !== keyboardHeightCache[keyboardType]
          ) {
            keyboardHeightCache[keyboardType] = this.cachedKeyboardHeight;
          }

          // 将输入框显示到键盘上方
          let topOffset = Math.max(0, minTopOffset, this.windowHeight -
            this.inputModalHeight -
            keyboardHeightCache[keyboardType])


          if (this.windowHeight - topOffset - keyboardHeightCache[keyboardType] < this.inputModalHeight) {
            if (adjustInputModalHeight) {
              // 调整输入框高度，输入框节点最好是flex布局，从而可以自适应高度的调整
              this.$refs.inputModalRef.style.height = `${this.windowHeight - topOffset - keyboardHeightCache[keyboardType]}px`
            } else {
              // 留给输入框的空间不够，输入框下面一部分可能会被键盘挡住
            }
          }

          this.$refs.inputModalRef.style.top = `${topOffset}px`
          this.$refs.inputModalRef.style.opacity = 1
        },
        judgeDeviceType.isAPP ? 650 : (keyboardHeightCache[keyboardType] ? 200 : 1000)
      ); // 微信大约250ms通知键盘高度事件，第一次需要多等一段时间才能得到正确的键盘高度，iosapp因为连续通知需要等待的时间可能会更长
    },


    /**
     * 阻止滚动穿透，绑定在modal元素根元素的touchmove上面，在modal上面有滚动元素时使用
     * @param {*} event 事件
     * @param {*} [innerScroll=null] 内部滚动容器
     */
    stopScrollChaining(event, innerScroll = null) {
      if (
        innerScroll &&
        (event.target === innerScroll || innerScroll.contains(event.target)) &&
        eleCanScroll(innerScroll)
      ) {
        // 不阻止内部滚动容器的滚动
      } else {
        // 阻止滚动向外传递
        event.preventDefault();
      }
    },

    // 安卓键盘收起
    onAndroidKeyboardDown() {
      if (window.innerHeight === winHeight) {
        this.onAndroidKeyboardDownEvent()
      }
    }
  }
}

function eleCanScroll(el) {
  return el.scrollHeight - el.clientHeight > 5;
}